// extracted by mini-css-extract-plugin
module.exports = {"secHeader":"F_V6_","left":"kjqeS","sponseredLogo":"Hl3WP","titleWrap":"uLIlg","hLeftIcon":"CjIMX","line":"ooVO6","seeAll":"US6wz","arrow":"YbRTA"};